import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ICheckout } from "../model/checkout.model";
import { IOrder } from "../../order/model/order.model";

@Injectable()
export class CheckoutService {
  authService = inject(AuthenticationService);

  constructor(private http: HttpClient) {}

  processPayment(checkout: ICheckout): Observable<string> {
    const token: string | null = this.authService.getUserToken() ?? null;

    if (!token) {
      // No token, cannot call API
      return of();
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<string>(
      `${environment.API_URL}/api/checkout/createOrder`,
      checkout,
      { headers }
    );
  }

  registerPayment(orderId: string, sessionId: string): Observable<IOrder> {
    const token: string | null = this.authService.getUserToken() ?? null;

    if (!token) {
      // No token, cannot call API
      return of({} as IOrder); // returning empty IOrder object to satisfy type
    }

    const params = {
      orderId: orderId,
      sessionId: sessionId
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<IOrder>(
      `${environment.API_URL}/api/payment/registerPayment`,
      params,
      { headers }
    );
  }
}
